// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/homepage_2_temp.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fly-in-from-bottom {
    0% {
        transform: translateY(80%) scale(90%);
        opacity: 0.5;
    }
    100% {
        transform: translateY(0%);
        opacity: 1;
    }
}

@keyframes unfade {
    0% {
        transform: translateY(15%) scale(80%);
        opacity: 0;
    }
    100% {
        transform: translateY(0%);
        opacity: 1;
    }
}

@keyframes content-fadein {
    0% {
        transform: translateY(20%);
        opacity: 0;
    }
    100% {
        transform: translateY(0%);
        opacity: 1;
    }
}

h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
}

.homepage-bg {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: 50% 80%;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
}

@keyframes htc-fadein {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.htc {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: var(--menuBarHeight);
    height: calc(100vh - var(--menuBarHeight));
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
}

.homepage-title {
    font-family: "Red Hat Display", Mulish, Lexend;
    font-size: 80px;
    font-weight: 700;
    column-gap: 20px;
    color: #fff;
    background: -webkit-linear-gradient(40deg, #77ffd6 40%, #3cc6d8);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    margin: 0;
    padding: 0;
    /*text-shadow: -2px 2px 30px rgba(0, 0, 0, 0.799);
    animation: fly-in-from-bottom 0.8s cubic-bezier( 0.24, 0.95, 0.68, 0.99 );*/
    animation: htc-fadein 0.5s ease-out;
    animation-delay: 0.5s;
    animation-fill-mode: both;
}
.homepage-subtitle {
    font-family: var(--paragraphFont);
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    column-gap: 20px;
    margin: 0;
    padding: 0;
    text-align: center;
    width: min(1000px, 90%);
    margin: 10px auto;
    margin-top: 0;
    animation: htc-fadein 0.5s ease-out;
    animation-delay: 0.8s;
    animation-fill-mode: both;
}

.htc-sitelinks {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    column-gap: 20px;
    width: 100%;
    box-sizing: border-box;
    row-gap: 10px;
    padding: 20px 50px;
    flex-wrap: wrap;
    background-color: #0003;
    animation: htc-fadein 0.5s ease-out;
    animation-delay: 1.1s;
    animation-fill-mode: both;
}

.htc-lookbelow {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 10px 30px;
    font-family: var(--paragraphFont);
    color: #fff;
    background-color: #000;
    border-radius: 8px;
    width: -moz-fit-content;
    width: fit-content;
    font-size: 16px;
    font-weight: 600;
    animation: htc-fadein 0.2s ease-out;
    animation-delay: 1.4s;
    animation-fill-mode: both;
}

.homepage-text-h1 {
    font-family: "Red Hat Display", Mulish, Lexend;
    font-size: 40px;
    font-weight: 700;
    padding: 0;
    margin: 0;
    word-wrap: break-word;
}
.homepage-text-h2 {
    font-family: "Red Hat Display", Mulish, Lexend;
    font-size: 30px;
    font-weight: 700;
    padding: 0;
    word-wrap: break-word;
}
.homepage-text-p {
    font-family: var(--paragraphFont);
    font-size: 18px;
    font-weight: 500;
    padding: 0;
    word-wrap: break-word;
}

/* Semi-small desktop (landscape) screens */
@media screen and (max-width: 1100px) and (max-height: 1200px) {
    .homepage-title {
        font-size: 40px !important;
    }
    .homepage-subtitle {
        font-size: 16px !important;
    }
    .homepage-section-heading {
        font-size: 40px !important;
    }
    .homepage-section-subheading {
        font-size: 18px !important;
    }
    .htc-lookbelow {
        display: none;
    }
    .homepage-content {
        gap: 50px !important;
        padding-top: 50px !important;
    }

    .homepage-text-h1 {
        font-size: 30px !important;
    }
    .homepage-text-h2 {
        font-size: 25px !important;
    }
    .homepage-text-p {
        font-size: 16px !important;
    }
}
/* Small desktop (landscape) screens */
@media screen and (max-width: 600px) and (max-height: 600px) {
    .homepage-title {
        font-size: 30px !important;
    }
    .homepage-subtitle {
        font-size: 14px !important;
    }
    .homepage-section-heading {
        font-size: 40px !important;
    }
    .homepage-section-subheading {
        font-size: 20px !important;
    }
    .homepage-content {
        gap: 30px !important;
        padding-top: 30px !important;
    }
    .htc-sitelinks {
        display: none;
    }
    .homepage-text-h1 {
        font-size: 26px !important;
    }
    .homepage-text-h2 {
        font-size: 22px !important;
    }
    .homepage-text-p {
        font-size: 14px !important;
    }
}
/* Tiny desktop (landscape) screens */
@media screen and (max-width: 400px) and (max-height: 400px) {
    .homepage-title {
        font-size: 20px !important;
    }
    .homepage-subtitle {
        font-size: 10px !important;
    }
    .homepage-section-heading {
        font-size: 30px !important;
    }
    .homepage-section-subheading {
        font-size: 20px !important;
    }
    .homepage-content {
        gap: 30px !important;
        padding-top: 30px !important;
    }
    .homepage-text-h1 {
        font-size: 22px !important;
    }
    .homepage-text-h2 {
        font-size: 18px !important;
    }
    .homepage-text-p {
        font-size: 14px !important;
    }

    .hpc-name {
        font-size: 24px !important;
    }
    .hpc-desc {
        font-size: 14px !important;
    }
    .homepage-project-card {
        font-size: 16px !important;
    }

    .stat-box-value {
        font-size: 40px !important;
    }
    .stat-box-title {
        font-size: 14px !important;
    }
}

/* Tablets (height slightly larger than width) */
@media screen and (max-width: 1100px) and (min-height: 1300px) {
    .homepage-title {
        font-size: 90px !important;
    }
    .homepage-subtitle {
        font-size: 24px !important;
    }
    .homepage-section-heading {
        font-size: 60px !important;
    }
    .homepage-section-subheading {
        font-size: 30px !important;
    }
    .htc-sitelinks {
        padding: 20px 10px !important;
    }
    .homepage-content {
        gap: 30px !important;
        padding-top: 30px !important;
    }
    .homepage-text-h1 {
        font-size: 26px !important;
    }
    .homepage-text-h2 {
        font-size: 22px !important;
    }
    .homepage-text-p {
        font-size: 14px !important;
    }
}

/* Mobile (portrait) */
@media screen and (max-width: 600px) and (min-height: 800px) {
    .homepage-title {
        font-size: 60px !important;
    }
    .homepage-subtitle {
        font-size: 16px !important;
    }
    .homepage-section-heading {
        font-size: 40px !important;
    }
    .homepage-section-subheading {
        font-size: 20px !important;
    }
    .htc-sitelinks {
        padding: 20px 10px !important;
    }
    .homepage-content {
        gap: 30px !important;
        padding-top: 30px !important;
    }
    .homepage-text-h1 {
        font-size: 26px !important;
    }
    .homepage-text-h2 {
        font-size: 22px !important;
    }
    .homepage-text-p {
        font-size: 14px !important;
    }
}
/* Tiny mobile (portrait) */
@media screen and (max-width: 300px) and (min-height: 500px) {
    .homepage-title {
        font-size: 40px !important;
    }
    .homepage-subtitle {
        font-size: 12px !important;
    }
    .homepage-section-heading {
        font-size: 30px !important;
    }
    .homepage-section-subheading {
        font-size: 16px !important;
    }
    .htc-sitelinks {
        padding: 20px 5px !important;
    }
    .homepage-content {
        gap: 30px !important;
        padding-top: 30px !important;
    }
    .homepage-text-h1 {
        font-size: 24px !important;
    }
    .homepage-text-h2 {
        font-size: 20px !important;
    }
    .homepage-text-p {
        font-size: 14px !important;
    }
}

/* Images */
.homepage-bottom-img {
    width: 100%;
    box-sizing: content-box;
}
.homepage-middle-img {
    width: calc(0.98 * var(--homepagePanelWidth));
    padding: 0;
    margin: 0;
}

.homepage-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 80px;
    padding-top: 100px;
    margin: 0;
    margin-top: 100vh;
    background-color: #fff;
    background-image: linear-gradient(to top, #bef, #fff 15%);
}
.hc-padding {
    padding-left: var(--_120px_6_padding);
    padding-right: var(--_120px_6_padding);
    box-sizing: border-box;
}
.homepage-section-panel {
    flex-wrap: wrap;
    display: flex;
    row-gap: 30px;
    column-gap: 60px;
    align-items: center;
    justify-content: center;
    flex-wrap: 1;
    margin: 0;
    line-height: 1;
    max-width: 100%;
    width: var(--homepagePanelWidth);
}
.homepage-image-container {
    display: flex;
    align-items: center;
    width: min(600px, 90%);
    flex-grow: 1;
}
.homepage-section-img {
    width: 100%;
}
.homepage-panel-text {
    max-width: 100%;
    width: min(500px, 90%);
    flex-grow: 1;
}
.homepage-section-generic {
    box-sizing: border-box;
    width: var(--homepagePanelWidth);
}


/* Stats */
#stats {
    padding: 0 var(--_120px_6_padding);
}

.stats-container {
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    padding: 0;
    color: #000;
}

.stat-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 35px calc(var(--_120px_6_padding) * 0.5);
    box-sizing: border-box;
    flex-grow: 1;
    height: 100%;
    max-height: 400px;
    background-color: #fff;
    transition: 0.2s;
    cursor: pointer;
}
.stat-box:hover {
    transform: scale(1.02);
    box-shadow: inherit, -3px 3px 10px 2px #0004;
}
.stat-box-value {
    font-family: "Red Hat Display", Mulish, Outfit;
    font-size: 50px;
    font-weight: 900;
    margin: 0;
    padding: 0;
    color: #000;
    transition: 0.2s;
}
.stat-box-title {
    font-size: 18px;
    font-weight: 700;
    margin: 0;
    padding: 0;
    color: #000;
    transition: 0.2s;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
}

.--sb-magenta {
    background-image: var(--crystalGradientMagenta);
    box-shadow: -3px 3px 8px 2px #4042;
}
.--sb-red {
    background-image: var(--crystalGradientRed);
    box-shadow: -3px 3px 8px 2px #4002;
}
.--sb-orange {
    background-image: var(--crystalGradientOrange);
    box-shadow: -3px 3px 8px 2px #4202;
}
.--sb-yellow {
    background-image: var(--crystalGradientYellow);
    box-shadow: -3px 3px 8px 2px #4402;
}

.hpt-border-y {
    border-top: 2px solid #808;
    border-bottom: 2px solid #404;
    padding: min(12%, 50px) min(5%, 30px);
    box-sizing: border-box;
    position: relative;
}
.hpt-border-y::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background: linear-gradient(to bottom, #8082, #8080);
}

.hpt-border-y hr {
    height: 2px;
    border: none;
    background: linear-gradient(to right, #808a, #088a);
}

.hpt-border-y-topline {
    position: absolute;
    top: -2%;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 80%;
}
.hpt-border-y-bottomline {
    position: absolute;
    bottom: -2%;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 80%;
}
.homepage-section-heading {
    font-family: "Red Hat Display", Mulish, Lexend;
    font-size: 50px;
    font-weight: 700;
    padding: 0;
    margin-bottom: 30px;
    position: relative;
    word-wrap: break-word;
    z-index: 2;
}

.hsh-lined::before {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 10px;
    border-radius: 10px;
}
.hsh-lined-thin::before {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 100%;
    height: 5px;
    border-radius: 5px;
}
.--hchc-blue_magenta::before {
    background-image: linear-gradient(to right, rgb(228, 32, 215), rgb(15, 182, 238));
}
.--hchc-yellow_red::before {
    background-image: linear-gradient(to right, rgb(217, 210, 4), rgb(184, 49, 49));
}
.--hchc-aqua_green::before {
    background-image: linear-gradient(to right, rgb(4, 217, 210), rgb(49, 184, 49));
}
.hch-text {
    width: -moz-fit-content;
    width: fit-content;
    margin: 0 auto;
    padding: 0 30px;
    box-sizing: border-box;
    background-color: #fff;
    z-index: 1;
}

.homepage-section-subheading {
    font-size: 20px;
    font-weight: 500;
    margin: 0;
    padding: 0;
}

.--2050-cta {
    padding-top: 30px;
    padding-bottom: 30px;
}

.homepage-projects-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;
    padding: 20px;
    margin: 0;
    background-color: #fff;
    background-image: linear-gradient(150deg, #bea, #adf);
}
.homepage-project-card {
    display: flex;
    flex-direction: column;
    padding: min(10%, 30px) min(8%, 30px);
    box-sizing: border-box;
    width: -moz-fit-content;
    width: fit-content;
    max-width: max(30%, 400px);
    flex-grow: 1;
    background-color: #fff;
    box-shadow: -3px 3px 15px 0 #0002;
}
.hpc-name {
    font-family: var(--displayFont);
    font-size: 30px;
}`, "",{"version":3,"sources":["webpack://./src/styles/home/HomePage.css"],"names":[],"mappings":"AAAA;IACI;QACI,qCAAqC;QACrC,YAAY;IAChB;IACA;QACI,yBAAyB;QACzB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,UAAU;IACd;IACA;QACI,yBAAyB;QACzB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,UAAU;IACd;IACA;QACI,yBAAyB;QACzB,UAAU;IACd;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,yDAAyD;IACzD,sBAAsB;IACtB,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;AACf;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gCAAgC;IAChC,0CAA0C;IAC1C,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,gEAAgE;IAChE,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;IACpC,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV;+EAC2E;IAC3E,mCAAmC;IACnC,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,mCAAmC;IACnC,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,mCAAmC;IACnC,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,iCAAiC;IACjC,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,qBAAqB;AACzB;AACA;IACI,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,qBAAqB;AACzB;;AAEA,2CAA2C;AAC3C;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,aAAa;IACjB;IACA;QACI,oBAAoB;QACpB,4BAA4B;IAChC;;IAEA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;AACJ;AACA,sCAAsC;AACtC;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,oBAAoB;QACpB,4BAA4B;IAChC;IACA;QACI,aAAa;IACjB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;AACJ;AACA,qCAAqC;AACrC;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,oBAAoB;QACpB,4BAA4B;IAChC;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,gDAAgD;AAChD;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,oBAAoB;QACpB,4BAA4B;IAChC;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,oBAAoB;QACpB,4BAA4B;IAChC;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;AACJ;AACA,2BAA2B;AAC3B;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,4BAA4B;IAChC;IACA;QACI,oBAAoB;QACpB,4BAA4B;IAChC;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,WAAW;AACX;IACI,WAAW;IACX,uBAAuB;AAC3B;AACA;IACI,6CAA6C;IAC7C,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,sBAAsB;IACtB,yDAAyD;AAC7D;AACA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,SAAS;IACT,cAAc;IACd,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,gCAAgC;AACpC;;;AAGA,UAAU;AACV;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iDAAiD;IACjD,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,4CAA4C;AAChD;AACA;IACI,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,+CAA+C;IAC/C,kCAAkC;AACtC;AACA;IACI,2CAA2C;IAC3C,kCAAkC;AACtC;AACA;IACI,8CAA8C;IAC9C,kCAAkC;AACtC;AACA;IACI,8CAA8C;IAC9C,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,qCAAqC;IACrC,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oDAAoD;AACxD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mDAAmD;AACvD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,cAAc;IACd,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,cAAc;IACd,UAAU;AACd;AACA;IACI,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,iFAAiF;AACrF;AACA;IACI,+EAA+E;AACnF;AACA;IACI,+EAA+E;AACnF;AACA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,qDAAqD;AACzD;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,qCAAqC;IACrC,sBAAsB;IACtB,uBAAkB;IAAlB,kBAAkB;IAClB,0BAA0B;IAC1B,YAAY;IACZ,sBAAsB;IACtB,iCAAiC;AACrC;AACA;IACI,+BAA+B;IAC/B,eAAe;AACnB","sourcesContent":["@keyframes fly-in-from-bottom {\n    0% {\n        transform: translateY(80%) scale(90%);\n        opacity: 0.5;\n    }\n    100% {\n        transform: translateY(0%);\n        opacity: 1;\n    }\n}\n\n@keyframes unfade {\n    0% {\n        transform: translateY(15%) scale(80%);\n        opacity: 0;\n    }\n    100% {\n        transform: translateY(0%);\n        opacity: 1;\n    }\n}\n\n@keyframes content-fadein {\n    0% {\n        transform: translateY(20%);\n        opacity: 0;\n    }\n    100% {\n        transform: translateY(0%);\n        opacity: 1;\n    }\n}\n\nh1, h2, h3, h4, h5, h6 {\n    margin: 0;\n    padding: 0;\n}\n\n.homepage-bg {\n    background-image: url('../../assets/homepage_2_temp.png');\n    background-size: cover;\n    background-position: 50% 80%;\n    width: 100vw;\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: -1;\n}\n\n@keyframes htc-fadein {\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n\n.htc {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-top: var(--menuBarHeight);\n    height: calc(100vh - var(--menuBarHeight));\n    box-sizing: border-box;\n    overflow: hidden;\n    position: relative;\n}\n\n.homepage-title {\n    font-family: \"Red Hat Display\", Mulish, Lexend;\n    font-size: 80px;\n    font-weight: 700;\n    column-gap: 20px;\n    color: #fff;\n    background: -webkit-linear-gradient(40deg, #77ffd6 40%, #3cc6d8);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n    text-align: center;\n    margin: 0;\n    padding: 0;\n    /*text-shadow: -2px 2px 30px rgba(0, 0, 0, 0.799);\n    animation: fly-in-from-bottom 0.8s cubic-bezier( 0.24, 0.95, 0.68, 0.99 );*/\n    animation: htc-fadein 0.5s ease-out;\n    animation-delay: 0.5s;\n    animation-fill-mode: both;\n}\n.homepage-subtitle {\n    font-family: var(--paragraphFont);\n    font-size: 20px;\n    font-weight: 600;\n    color: #fff;\n    column-gap: 20px;\n    margin: 0;\n    padding: 0;\n    text-align: center;\n    width: min(1000px, 90%);\n    margin: 10px auto;\n    margin-top: 0;\n    animation: htc-fadein 0.5s ease-out;\n    animation-delay: 0.8s;\n    animation-fill-mode: both;\n}\n\n.htc-sitelinks {\n    margin: 0 auto;\n    display: flex;\n    justify-content: center;\n    column-gap: 20px;\n    width: 100%;\n    box-sizing: border-box;\n    row-gap: 10px;\n    padding: 20px 50px;\n    flex-wrap: wrap;\n    background-color: #0003;\n    animation: htc-fadein 0.5s ease-out;\n    animation-delay: 1.1s;\n    animation-fill-mode: both;\n}\n\n.htc-lookbelow {\n    position: absolute;\n    bottom: 20px;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    padding: 10px 30px;\n    font-family: var(--paragraphFont);\n    color: #fff;\n    background-color: #000;\n    border-radius: 8px;\n    width: fit-content;\n    font-size: 16px;\n    font-weight: 600;\n    animation: htc-fadein 0.2s ease-out;\n    animation-delay: 1.4s;\n    animation-fill-mode: both;\n}\n\n.homepage-text-h1 {\n    font-family: \"Red Hat Display\", Mulish, Lexend;\n    font-size: 40px;\n    font-weight: 700;\n    padding: 0;\n    margin: 0;\n    word-wrap: break-word;\n}\n.homepage-text-h2 {\n    font-family: \"Red Hat Display\", Mulish, Lexend;\n    font-size: 30px;\n    font-weight: 700;\n    padding: 0;\n    word-wrap: break-word;\n}\n.homepage-text-p {\n    font-family: var(--paragraphFont);\n    font-size: 18px;\n    font-weight: 500;\n    padding: 0;\n    word-wrap: break-word;\n}\n\n/* Semi-small desktop (landscape) screens */\n@media screen and (max-width: 1100px) and (max-height: 1200px) {\n    .homepage-title {\n        font-size: 40px !important;\n    }\n    .homepage-subtitle {\n        font-size: 16px !important;\n    }\n    .homepage-section-heading {\n        font-size: 40px !important;\n    }\n    .homepage-section-subheading {\n        font-size: 18px !important;\n    }\n    .htc-lookbelow {\n        display: none;\n    }\n    .homepage-content {\n        gap: 50px !important;\n        padding-top: 50px !important;\n    }\n\n    .homepage-text-h1 {\n        font-size: 30px !important;\n    }\n    .homepage-text-h2 {\n        font-size: 25px !important;\n    }\n    .homepage-text-p {\n        font-size: 16px !important;\n    }\n}\n/* Small desktop (landscape) screens */\n@media screen and (max-width: 600px) and (max-height: 600px) {\n    .homepage-title {\n        font-size: 30px !important;\n    }\n    .homepage-subtitle {\n        font-size: 14px !important;\n    }\n    .homepage-section-heading {\n        font-size: 40px !important;\n    }\n    .homepage-section-subheading {\n        font-size: 20px !important;\n    }\n    .homepage-content {\n        gap: 30px !important;\n        padding-top: 30px !important;\n    }\n    .htc-sitelinks {\n        display: none;\n    }\n    .homepage-text-h1 {\n        font-size: 26px !important;\n    }\n    .homepage-text-h2 {\n        font-size: 22px !important;\n    }\n    .homepage-text-p {\n        font-size: 14px !important;\n    }\n}\n/* Tiny desktop (landscape) screens */\n@media screen and (max-width: 400px) and (max-height: 400px) {\n    .homepage-title {\n        font-size: 20px !important;\n    }\n    .homepage-subtitle {\n        font-size: 10px !important;\n    }\n    .homepage-section-heading {\n        font-size: 30px !important;\n    }\n    .homepage-section-subheading {\n        font-size: 20px !important;\n    }\n    .homepage-content {\n        gap: 30px !important;\n        padding-top: 30px !important;\n    }\n    .homepage-text-h1 {\n        font-size: 22px !important;\n    }\n    .homepage-text-h2 {\n        font-size: 18px !important;\n    }\n    .homepage-text-p {\n        font-size: 14px !important;\n    }\n\n    .hpc-name {\n        font-size: 24px !important;\n    }\n    .hpc-desc {\n        font-size: 14px !important;\n    }\n    .homepage-project-card {\n        font-size: 16px !important;\n    }\n\n    .stat-box-value {\n        font-size: 40px !important;\n    }\n    .stat-box-title {\n        font-size: 14px !important;\n    }\n}\n\n/* Tablets (height slightly larger than width) */\n@media screen and (max-width: 1100px) and (min-height: 1300px) {\n    .homepage-title {\n        font-size: 90px !important;\n    }\n    .homepage-subtitle {\n        font-size: 24px !important;\n    }\n    .homepage-section-heading {\n        font-size: 60px !important;\n    }\n    .homepage-section-subheading {\n        font-size: 30px !important;\n    }\n    .htc-sitelinks {\n        padding: 20px 10px !important;\n    }\n    .homepage-content {\n        gap: 30px !important;\n        padding-top: 30px !important;\n    }\n    .homepage-text-h1 {\n        font-size: 26px !important;\n    }\n    .homepage-text-h2 {\n        font-size: 22px !important;\n    }\n    .homepage-text-p {\n        font-size: 14px !important;\n    }\n}\n\n/* Mobile (portrait) */\n@media screen and (max-width: 600px) and (min-height: 800px) {\n    .homepage-title {\n        font-size: 60px !important;\n    }\n    .homepage-subtitle {\n        font-size: 16px !important;\n    }\n    .homepage-section-heading {\n        font-size: 40px !important;\n    }\n    .homepage-section-subheading {\n        font-size: 20px !important;\n    }\n    .htc-sitelinks {\n        padding: 20px 10px !important;\n    }\n    .homepage-content {\n        gap: 30px !important;\n        padding-top: 30px !important;\n    }\n    .homepage-text-h1 {\n        font-size: 26px !important;\n    }\n    .homepage-text-h2 {\n        font-size: 22px !important;\n    }\n    .homepage-text-p {\n        font-size: 14px !important;\n    }\n}\n/* Tiny mobile (portrait) */\n@media screen and (max-width: 300px) and (min-height: 500px) {\n    .homepage-title {\n        font-size: 40px !important;\n    }\n    .homepage-subtitle {\n        font-size: 12px !important;\n    }\n    .homepage-section-heading {\n        font-size: 30px !important;\n    }\n    .homepage-section-subheading {\n        font-size: 16px !important;\n    }\n    .htc-sitelinks {\n        padding: 20px 5px !important;\n    }\n    .homepage-content {\n        gap: 30px !important;\n        padding-top: 30px !important;\n    }\n    .homepage-text-h1 {\n        font-size: 24px !important;\n    }\n    .homepage-text-h2 {\n        font-size: 20px !important;\n    }\n    .homepage-text-p {\n        font-size: 14px !important;\n    }\n}\n\n/* Images */\n.homepage-bottom-img {\n    width: 100%;\n    box-sizing: content-box;\n}\n.homepage-middle-img {\n    width: calc(0.98 * var(--homepagePanelWidth));\n    padding: 0;\n    margin: 0;\n}\n\n.homepage-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 80px;\n    padding-top: 100px;\n    margin: 0;\n    margin-top: 100vh;\n    background-color: #fff;\n    background-image: linear-gradient(to top, #bef, #fff 15%);\n}\n.hc-padding {\n    padding-left: var(--_120px_6_padding);\n    padding-right: var(--_120px_6_padding);\n    box-sizing: border-box;\n}\n.homepage-section-panel {\n    flex-wrap: wrap;\n    display: flex;\n    row-gap: 30px;\n    column-gap: 60px;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: 1;\n    margin: 0;\n    line-height: 1;\n    max-width: 100%;\n    width: var(--homepagePanelWidth);\n}\n.homepage-image-container {\n    display: flex;\n    align-items: center;\n    width: min(600px, 90%);\n    flex-grow: 1;\n}\n.homepage-section-img {\n    width: 100%;\n}\n.homepage-panel-text {\n    max-width: 100%;\n    width: min(500px, 90%);\n    flex-grow: 1;\n}\n.homepage-section-generic {\n    box-sizing: border-box;\n    width: var(--homepagePanelWidth);\n}\n\n\n/* Stats */\n#stats {\n    padding: 0 var(--_120px_6_padding);\n}\n\n.stats-container {\n    box-sizing: border-box;\n    position: relative;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 20px;\n    padding: 0;\n    color: #000;\n}\n\n.stat-box {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 35px calc(var(--_120px_6_padding) * 0.5);\n    box-sizing: border-box;\n    flex-grow: 1;\n    height: 100%;\n    max-height: 400px;\n    background-color: #fff;\n    transition: 0.2s;\n    cursor: pointer;\n}\n.stat-box:hover {\n    transform: scale(1.02);\n    box-shadow: inherit, -3px 3px 10px 2px #0004;\n}\n.stat-box-value {\n    font-family: \"Red Hat Display\", Mulish, Outfit;\n    font-size: 50px;\n    font-weight: 900;\n    margin: 0;\n    padding: 0;\n    color: #000;\n    transition: 0.2s;\n}\n.stat-box-title {\n    font-size: 18px;\n    font-weight: 700;\n    margin: 0;\n    padding: 0;\n    color: #000;\n    transition: 0.2s;\n    white-space: nowrap;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n}\n\n.--sb-magenta {\n    background-image: var(--crystalGradientMagenta);\n    box-shadow: -3px 3px 8px 2px #4042;\n}\n.--sb-red {\n    background-image: var(--crystalGradientRed);\n    box-shadow: -3px 3px 8px 2px #4002;\n}\n.--sb-orange {\n    background-image: var(--crystalGradientOrange);\n    box-shadow: -3px 3px 8px 2px #4202;\n}\n.--sb-yellow {\n    background-image: var(--crystalGradientYellow);\n    box-shadow: -3px 3px 8px 2px #4402;\n}\n\n.hpt-border-y {\n    border-top: 2px solid #808;\n    border-bottom: 2px solid #404;\n    padding: min(12%, 50px) min(5%, 30px);\n    box-sizing: border-box;\n    position: relative;\n}\n.hpt-border-y::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 50px;\n    background: linear-gradient(to bottom, #8082, #8080);\n}\n\n.hpt-border-y hr {\n    height: 2px;\n    border: none;\n    background: linear-gradient(to right, #808a, #088a);\n}\n\n.hpt-border-y-topline {\n    position: absolute;\n    top: -2%;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    width: 80%;\n}\n.hpt-border-y-bottomline {\n    position: absolute;\n    bottom: -2%;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    width: 80%;\n}\n.homepage-section-heading {\n    font-family: \"Red Hat Display\", Mulish, Lexend;\n    font-size: 50px;\n    font-weight: 700;\n    padding: 0;\n    margin-bottom: 30px;\n    position: relative;\n    word-wrap: break-word;\n    z-index: 2;\n}\n\n.hsh-lined::before {\n    content: \"\";\n    position: absolute;\n    bottom: -10px;\n    left: 0;\n    width: 100%;\n    height: 10px;\n    border-radius: 10px;\n}\n.hsh-lined-thin::before {\n    content: \"\";\n    position: absolute;\n    bottom: -5px;\n    left: 0;\n    width: 100%;\n    height: 5px;\n    border-radius: 5px;\n}\n.--hchc-blue_magenta::before {\n    background-image: linear-gradient(to right, rgb(228, 32, 215), rgb(15, 182, 238));\n}\n.--hchc-yellow_red::before {\n    background-image: linear-gradient(to right, rgb(217, 210, 4), rgb(184, 49, 49));\n}\n.--hchc-aqua_green::before {\n    background-image: linear-gradient(to right, rgb(4, 217, 210), rgb(49, 184, 49));\n}\n.hch-text {\n    width: fit-content;\n    margin: 0 auto;\n    padding: 0 30px;\n    box-sizing: border-box;\n    background-color: #fff;\n    z-index: 1;\n}\n\n.homepage-section-subheading {\n    font-size: 20px;\n    font-weight: 500;\n    margin: 0;\n    padding: 0;\n}\n\n.--2050-cta {\n    padding-top: 30px;\n    padding-bottom: 30px;\n}\n\n.homepage-projects-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 30px;\n    padding: 20px;\n    margin: 0;\n    background-color: #fff;\n    background-image: linear-gradient(150deg, #bea, #adf);\n}\n.homepage-project-card {\n    display: flex;\n    flex-direction: column;\n    padding: min(10%, 30px) min(8%, 30px);\n    box-sizing: border-box;\n    width: fit-content;\n    max-width: max(30%, 400px);\n    flex-grow: 1;\n    background-color: #fff;\n    box-shadow: -3px 3px 15px 0 #0002;\n}\n.hpc-name {\n    font-family: var(--displayFont);\n    font-size: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
